import React from 'react'
import { Helmet } from 'react-helmet-async'
import CreditBalanceLayout from '../../layouts/Billing/CreditBalanceLayout'

const CreditBalancePage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Credit balance</title>
      <meta name="description" content="Credit balance page" />
    </Helmet>
    <CreditBalanceLayout />
  </React.Fragment>
)

export default CreditBalancePage
